import classNames from "classnames";
import { observer } from "mobx-react";
import { type FunctionComponent } from "react";

import CloseIcon from "nvent-web/assets/svg/side-menu/close.svg";
import { Notification as NotificationModel } from "nvent-web/stores/Notifications";
import { compose } from "nvent-web/utils/compose";

import style from "./Notification.module.scss";

export interface NotificationProps {
  notification: NotificationModel;
}

export const NotificationInner: FunctionComponent<NotificationProps> = ({
  notification,
}) => {
  const close = () => {
    notification.close();
  };

  if (notification.isClosed || notification.hasExpired) {
    return null;
  }

  return (
    <div className={classNames(style.root, style[notification.theme])}>
      <span>{notification.message}</span>
      <button type="button" className={style.closeButton} onClick={close}>
        <img src={CloseIcon} />
      </button>
    </div>
  );
};

export const Notification =
  compose<NotificationProps>(observer)(NotificationInner);
